<template>
  <div class="home">
    <!-- <div class="btn" @click="headlApp">
      <div class="btns_1">
        <svg
          t="1705645205176"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3682"
          width="100%"
          height="100%"
        >
          <path
            d="M502.647516 415.492084l0 85.939251 24.592418 0c33.344949 0 50.001413-14.500589 50.001413-43.484813 0-28.312691-16.485048-42.453497-49.486226-42.453497l-25.107605 0zM833.388274 304.007271l0-240.005651c0-35.359548-28.656463-64.001884-64.001884-64.001884l-512.019779 0c-35.343537 0-64.001884 28.641394-64.001884 64.001884l0 240.005651-119.386861 0 0 400.008477 119.386861 0 0 256.005651c0 35.344478 28.657405 64.001884 64.001884 64.001884l512.019779 0c35.344478 0 64.001884-28.656463 64.001884-64.001884l0-256.005651 118.225571 0 0-400.008477-118.225571 0zM769.388274 80.00162l0 224.005651-512.012244 0-0.006593-224.005651 512.020721 0zM636.899458 455.712475c0 27.265364-10.000471 49.126442-30.000471 65.564398-20.000942 16.453968-45.002119 24.330586-75.031787 23.6421l-29.218743 0 0 92.813751-56.720509 0 0-266.241582 91.626089 0c66.218978 0 99.343537 28.079115 99.343537 84.221333zM226.280198 576.716478l-19.593125 61.01813-61.540852 0 97.455145-266.24064 66.696492 0 95.564869 266.24064-61.876148 0-19.936897-61.01813-96.767601 0zM513.382623 992.02234c-17.671768 0-32.016953-14.329174-32.016953-32.000942s14.345185-32.000942 32.016953-32.000942 32.000942 14.329174 32.000942 32.000942-14.329174 32.000942-32.000942 32.000942zM769.388274 896.020457l-512.020721 0 0.006593-192.003767 512.011302 0 0 192.003767zM830.857547 521.276873c-19.984931 16.453968-45.002119 24.330586-75.01766 23.6421l-29.218743 0 0 92.813751-56.719567 0 0-266.241582 91.595008 0c66.251943 0 99.348246 28.078173 99.348246 84.221333-0.000942 27.265364-9.986343 49.126442-29.988227 65.564398zM751.714622 415.492084l-25.09442 0 0 85.939251 24.562279 0c33.344949 0 50.033435-14.500589 50.033435-43.484813 0.000942-28.312691-16.50106-42.454438-49.501295-42.454438zM275.267247 417.384243l-1.562515 0c-0.687544 7.780551-2.218036 15.297386-4.625383 22.5166l-30.429951 92.98705 70.995055 0-30.250059-92.298564c-1.954321-5.845067-3.328467-13.58041-4.126207-23.204144z"
            fill="#3A97E4"
            p-id="3683"
          />
        </svg>
      </div>
    </div> -->
    <div class="btn" @click="headlehongbao">
      <div class="btns_1">
        <img class="hongbao" src="../../public/hongbao.png" alt="" />
      </div>
    </div>
    <div class="btn" @click="customerService">
      <div class="btns_2">
        <svg
          t="1705645310052"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4104"
          width="100%"
          height="100%"
        >
          <path
            d="M288.460645 330.313136a36.351245 36.351245 0 0 0-36.703237 36.703237v102.02988a36.703237 36.703237 0 0 0 73.406475 0v-102.02988a36.351245 36.351245 0 0 0-36.703238-36.703237z"
            fill="#3A97E4"
            p-id="4105"
          />
          <path
            d="M551.287184 469.046253v-102.02988a36.703237 36.703237 0 1 0-73.406475 0v102.02988a36.703237 36.703237 0 0 0 73.406475 0z"
            fill="#3A97E4"
            p-id="4106"
          />
          <path
            d="M767.906682 469.046253v-102.02988a36.703237 36.703237 0 1 0-73.406475 0v102.02988a36.703237 36.703237 0 0 0 73.406475 0z"
            fill="#3A97E4"
            p-id="4107"
          />
          <path
            d="M515.303931 0a418.583301 418.583301 0 0 0-265.59448 739.904624 35.663259 35.663259 0 0 0 23.359514 8.815817 34.815276 34.815276 0 0 0 27.727424-13.215726 36.351245 36.351245 0 0 0-4.383909-51.374932A342.744877 342.744877 0 1 1 515.303931 763.392136a34.14329 34.14329 0 0 0-25.599468 11.007771L302.924345 960.844032a37.07123 37.07123 0 0 0 25.599468 63.134688 34.14329 34.14329 0 0 0 25.599468-11.007771L530.631613 836.782611A418.599301 418.599301 0 0 0 515.303931 0z"
            fill="#3A97E4"
            p-id="4108"
          />
        </svg>
      </div>
    </div>
    <!-- <div class="btn" @click="handleqq">
      <div class="btns_3">
        <svg
          t="1705645321286"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4245"
          width="100%"
          height="100%"
        >
          <path
            d="M662.653 949.219c-3.779 0-7.668-0.02-11.695-0.06-58.766-0.581-105.413-2.615-138.755-6.048-33.859 3.433-80.633 5.467-139.131 6.048-89.695 0.897-115.737-8.836-130.513-19.479a37.012 37.012 0 0 1-11.537-13.612c-4.5-9.093-5.955-19.45-4.449-31.662 1.866-14.973 10.469-28.383 25.582-39.911 5.982-4.709 12.48-9.016 19.44-12.889-11.962-15.524-21.851-31.844-29.581-48.847a309.593 309.593 0 0 1-3.065-6.968c-15.077 17.037-28.899 26.224-43.755 29.552a36.98 36.98 0 0 1-8.087 0.895c-13.828 0-26.329-6.833-34.297-18.748-3.525-5.271-6.105-11.46-7.888-18.922-2.131-8.917-3.294-20.203-3.662-35.514-0.686-28.804 7.327-71.482 24.496-130.48 0.104-0.356 0.213-0.711 0.327-1.064 9.649-29.786 21.09-61.478 34.006-94.195 10.909-27.621 19.705-49.981 26.206-66.621v-20.599c-0.614-86.662 20.875-164.649 63.872-231.793 46.041-71.911 120.334-110.098 220.817-113.499a36.883 36.883 0 0 1 2.511 0c99.835 3.402 173.955 41.553 220.3 113.394 43.358 67.207 65.018 145.277 64.377 232.04-0.002 0.304-0.008 0.607-0.018 0.911l-0.642 20.05 26.367 66.871c13.305 32.94 24.664 64.529 33.762 93.893 0.052 0.168 0.103 0.337 0.153 0.506 17.149 58.28 25.319 100.7 24.978 129.685-0.181 15.441-1.204 26.819-3.218 35.803-1.686 7.516-4.186 13.758-7.644 19.084-7.804 12.021-20.719 19.198-34.548 19.198-2.721 0-5.433-0.3-8.087-0.895-14.887-3.335-28.824-12.594-44.156-29.8a311.701 311.701 0 0 1-2.981 6.931c-7.625 17.17-17.489 33.645-29.508 49.312a173.95 173.95 0 0 1 19.012 12.202c0.532 0.393 1.053 0.8 1.563 1.221 13.361 11.024 21.404 23.473 23.906 36.998 3.538 18.976-2.401 31.967-8.008 39.514a36.986 36.986 0 0 1-7.387 7.45c-15.89 12.014-42.634 20.047-119.063 20.048z m65.014-45.512z m-368.938-28.496c4.296 0.015 8.823 0 13.608-0.047 58.441-0.581 104.173-2.614 135.925-6.043a36.92 36.92 0 0 1 8.017 0.008c31.138 3.424 76.696 5.455 135.41 6.035 4.95 0.049 9.628 0.062 14.05 0.046a37.002 37.002 0 0 1-1.604-56.969c22.985-20.155 39.934-42.296 50.376-65.809 10.526-23.686 15.861-45.679 15.861-65.378 0-17.178 11.823-32.097 28.547-36.021 15.528-3.646 31.49 3.082 39.81 16.378-3.027-12.49-6.907-26.989-11.848-43.793-8.491-27.375-19.144-56.967-31.666-87.96l-0.115-0.288-29.233-74.139a36.978 36.978 0 0 1-2.56-14.756l0.872-27.233c0.455-71.92-17.229-136.154-52.565-190.927-32.698-50.685-84.839-76.699-159.383-79.507-75.076 2.809-127.339 28.789-159.743 79.399-35.164 54.913-52.724 119.337-52.192 191.486l0.001 0.272v27.693c0 4.595-0.856 9.15-2.524 13.432-6.713 17.231-16.421 41.929-28.854 73.405-12.272 31.086-23.127 61.127-32.266 89.296-4.82 16.592-8.611 30.913-11.573 43.265 8.38-13.061 24.197-19.634 39.584-16.023 16.724 3.924 28.547 18.843 28.547 36.021 0 19.579 5.441 41.476 16.171 65.085 10.746 23.64 27.89 45.88 50.953 66.101a37 37 0 0 1-1.606 56.971z m380.433-6.393z m109.735-134.485c0.001 0 0.001 0 0 0 0.001 0 0.001 0 0 0z"
            fill="#3A97E4"
            p-id="4246"
          />
        </svg>
      </div>
    </div> -->
    <div class="btn" @click="handlebag">
      <div class="btns_4">
        <svg
          t="1705645169789"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3548"
          width="100%"
          height="100%"
        >
          <path
            d="M512 64.5c196.613 0 356 159.387 356 356v100h40.5l0.86 0.007c28.322 0.46 51.14 23.561 51.14 51.993V752l-0.007 0.86c-0.46 28.322-23.561 51.14-51.993 51.14H868v31c0 68.892-55.29 124.87-123.916 125.983L742 961H282c-69.588 0-126-56.412-126-126v-31h-40.5c-28.432 0-51.534-22.818-51.993-51.14L63.5 752V572.5c0-28.432 22.818-51.534 51.14-51.993l0.86-0.007H156v-100c0-194.647 156.215-352.809 350.113-355.952z m0 72c-156.849 0-284 127.151-284 284V835c0 29.823 24.177 54 54 54h460c29.823 0 54-24.177 54-54V420.5c0-156.849-127.151-284-284-284z m212 384c19.882 0 36 16.118 36 36V793c0 28.719-23.281 52-52 52H317c-28.719 0-52-23.281-52-52V556.5c0-19.882 16.118-36 36-36z m-36 72H337V773h351V592.5z m-532 0h-20.5V732H156V592.5z m732.5 0H868V732h20.5V592.5zM609 220c19.882 0 36 16.118 36 36 0 19.683-15.797 35.677-35.405 35.995L609 292H416c-19.882 0-36-16.118-36-36 0-19.683 15.797-35.677 35.405-35.995L416 220h193z"
            fill="#3A97E4"
            p-id="3549"
          />
        </svg>
      </div>
    </div>
    <div class="btn" @click="handlerecharge">
      <div class="btns_5">
        <svg
          t="1705645213053"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3820"
          width="100%"
          height="100%"
        >
          <path
            d="M506.1 922.7c-222.4 0-403.3-184.9-403.3-412.2S283.7 98.2 506.1 98.2c164.2 0 310.6 100.3 373.1 255.4 8.5 21.1-1.7 45.1-22.8 53.6-21.2 8.5-45.1-1.7-53.6-22.8C753 260.6 636.5 180.6 506.2 180.6c-176.9 0-320.9 147.9-320.9 329.8s144 329.8 320.9 329.8c161.2 0 298-123.7 318.3-287.8 2.8-22.6 23.5-38.7 46-35.8 22.6 2.8 38.6 23.4 35.9 46-25.5 205.3-197.5 360.1-400.3 360.1z"
            fill="#3A97E4"
            p-id="3821"
          />
          <path
            d="M846.5 423.2c-4.1 0-8.2-0.6-12.2-1.8l-130.8-40.5c-21.7-6.7-33.9-29.8-27.2-51.6 6.7-21.8 29.8-34 51.6-27.2l90.9 28.1 27.7-94c6.4-21.8 29.4-34.3 51.2-27.9 21.8 6.4 34.3 29.4 27.9 51.2l-39.5 134.1c-3.1 10.6-10.3 19.5-20.1 24.7-6.1 3.3-12.8 4.9-19.5 4.9zM613.9 516.3H395.5c-22.8 0-41.2-18.5-41.2-41.2s18.5-41.2 41.2-41.2h218.4c22.8 0 41.2 18.5 41.2 41.2s-18.4 41.2-41.2 41.2zM613.9 641.5H395.5c-22.8 0-41.2-18.5-41.2-41.2s18.5-41.2 41.2-41.2h218.4c22.8 0 41.2 18.5 41.2 41.2s-18.4 41.2-41.2 41.2z"
            fill="#3A97E4"
            p-id="3822"
          />
          <path
            d="M504.7 722.6c-22.8 0-41.2-18.5-41.2-41.2V494.1c0-22.8 18.5-41.2 41.2-41.2s41.2 18.5 41.2 41.2v187.3c0 22.8-18.4 41.2-41.2 41.2z"
            fill="#3A97E4"
            p-id="3823"
          />
          <path
            d="M488.4 491.3c-10.5 0-21.1-4-29.1-12.1l-83.7-83.6c-16.1-16.1-16.1-42.2 0-58.3 16.1-16.1 42.2-16.1 58.3 0l83.7 83.6c16.1 16.1 16.1 42.2 0 58.3-8.1 8.1-18.7 12.1-29.2 12.1z"
            fill="#3A97E4"
            p-id="3824"
          />
          <path
            d="M519.4 491.3c-10.5 0-21.1-4-29.1-12.1-16.1-16.1-16.1-42.2 0-58.3l85.2-85.2c16.1-16.1 42.2-16.1 58.3 0 16.1 16.1 16.1 42.2 0 58.3l-85.2 85.2c-8.1 8.1-18.6 12.1-29.2 12.1z"
            fill="#3A97E4"
            p-id="3825"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import customer from "../../public/config.json"
export default {
  data() {
    return {};
  },
  methods: {
    handlerecharge() {
      this.$store.commit("playAudio");

      this.$router.push("recharge");
      this.$bus.$emit("sliderbtn", false);
    },
    handlebag() {
      this.$store.commit("playAudio");

      this.$router.push("knapsack");
      this.$bus.$emit("sliderbtn", false);
    },
    handleqq() {
      // localStorage.setItem("help-type", 'gywm');
      this.$store.commit("playAudio");

      // this.$router.push("help");
      window.location.href = "https://qm.qq.com/q/OZgO7OCVmU";
      this.$bus.$emit("sliderbtn", false);
    },
    headlApp() {
      this.$store.commit("playAudio");
      this.$router.push("/downloadApp");
      // this.$message({ duration: 1000,
      //         message: "敬请期待！",
      //         type: "success",
      //         customClass: "log_success"
      //       });
      this.$bus.$emit("sliderbtn", false);
      this.$store.showstate = false;
    },
    headlehongbao() {
      this.$store.commit("playAudio");
      this.$router.push("/hongbao");
    },
    customerService() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const customerServiceAddress = customer.customerServiceAddress;
      const url = customerServiceAddress.url;
      const noCanClose = customerServiceAddress.noCanClose;
      const kefu_id = customerServiceAddress.kefu_id;
      const token = customerServiceAddress.token;
      if (userInfo) {
        window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}&phone=${userInfo.mobile}&nickName=${userInfo.name}`;
      } else {
        window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}`;
      }
      // window.location.href =? customerServiceAddress.customerServiceAddress;
    },
  },
};
</script>

<style lang="scss" scoped>
.hongbao {
  width: 28px !important;
  height: 31px !important;
}
@media (max-width: 550px) {
  .hongbao {
    width: 20px !important;
    height: 23px !important;
  }
  .home {
    width: 50px !important;
    height: 238px !important;
    border-radius: 31px !important;
    .btn {
      width: 44px !important;
      height: 44px !important;
      .btns_1 {
        width: 20px !important;
        height: 24px !important;
      }
      .btns_2 {
        width: 19px !important;
        height: 24px !important;
      }
      .btns_3 {
        width: 20px !important;
        height: 20px !important;
      }
      .btns_4 {
        width: 21px !important;
        height: 21px !important;
      }
      .btns_5 {
        width: 21px !important;
        height: 21px !important;
      }
    }
  }
}
.home {
  width: 70px;
  height: 333px;
  background: #323436;
  border-radius: 44px 44px 44px 44px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;

  .btn {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btns_1 {
      width: 28px;
      height: 33px;
    }
    .btns_2 {
      width: 27px;
      height: 33px;
    }
    .btns_3 {
      width: 32px;
      height: 32px;
    }
    .btns_4 {
      width: 33px;
      height: 33px;
    }
    .btns_5 {
      width: 33px;
      height: 33px;
    }
  }
}
</style>